export default __webpack_public_path__ + "static/media/About1.feb18cc7.png";